import { createSlice } from "@reduxjs/toolkit";

const payrollSlice = createSlice({
  name: "payroll",
  initialState: {
    isLoading: false,
    incomeDeductionList: [],
    currentIncomeDeduction: {},
    welfareList: [],
    currentWelfare: {},
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIncomeDeductionList(state, action) {
      state.incomeDeductionList = action.payload;
    },
    setCurrentIncomeDeduction(state, action) {
      state.currentIncomeDeduction = action.payload;
    },
    setWelfaleList(state, action) {
      state.welfareList = action.payload;
    },
    setCurrentWelfare(state, action) {
      state.currentWelfare = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setIncomeDeductionList,
  setCurrentIncomeDeduction,
  setWelfaleList,
  setCurrentWelfare,
} = payrollSlice.actions;
export default payrollSlice.reducer;
